var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",attrs:{"id":"exporo-invest-button"}},[_c('button',{class:_vm.dataClass,style:(_vm.dataStyle),on:{"click":_vm.navigate}},[_vm._t("default",[_vm._v(_vm._s(_vm.trans.get('invest_button.label')))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }